import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });

  // Tag every event with the environment so a single API key
  // can be shared across dev / staging / prod.
  const APP_ENV = process.env.REACT_APP_POSTHOG_ENV || 'development';
  posthog.register({ environment: APP_ENV });
}

export default posthog;
